import { render, staticRenderFns } from "./knowledgehub-article.vue?vue&type=template&id=78b31d0e&"
import script from "./knowledgehub-article.vue?vue&type=script&lang=js&"
export * from "./knowledgehub-article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports